import Scene from "./Scene";
import common from "../common";
import {saveImage, translate} from "../utils";
import OutsideGate from "../game/OutsideGate";
import PlayerCharacter from "../game/PlayerCharacter";
import FlockController from "../game/flocking/FlockController";
import Button from "../ui/Button";
import DrawingSpine from "../drawing/DrawingSpine";
import paper from "paper";
import DrawingTextureHack from "../drawing/DrawingTextureHack";
import {GlowFilter} from "pixi-filters";
import Drawing from "../drawing/Drawing";
import ObstacleManager from "../game/ObstacleManager";

export default class ResultsScene extends Scene {
    constructor() {
        super();

        this._state = null;
    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture("results_bg"));
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this.addChild(this._bg);

        this._gate = new OutsideGate();
        // this._gate.position.set();
        this.addChild(this._gate);

        /*
        this._velma = new PIXI.AnimatedSprite([P3.assets.texture("velma_2"), P3.assets.texture("velma_1")]);
        // this._velma.scale.set(1.5);
        this._velma.autoUpdate = false;
        this._velma.loop = false;
        this._velma.gotoAndStop(0);
        this._velma.anchor.set(0.5, 1);
        this._velma.position.set(common.STAGE_WIDTH * 0.5 - 20, common.STAGE_HEIGHT * 0.5 + 280);
        this.addChild(this._velma);

        this._daphne = new PIXI.AnimatedSprite([P3.assets.texture("daphne_1"), P3.assets.texture("daphne_2")]);
        //  this._daphne.scale.set(1.5);
        this._daphne.autoUpdate = false;
        // this._daphne.loop = true;
        this._daphne.gotoAndStop(0);
        this._daphne.anchor.set(0.5, 1);
        this._daphne.position.set(common.STAGE_WIDTH * 0.5 + 180, common.STAGE_HEIGHT * 0.5 + 380);
        this.addChild(this._daphne);

         */

        this._flockHolder = new PIXI.Container();
        this.addChild(this._flockHolder);

        const settings = {
            limits: {velocity: 320, force: 8},
            weights: {s: 1.3, a: 0.9, c: 0.8, t: 1.1},
            separation: 200,
            sense: 400,
            targeting: false,
            wrapAround: false,
            bounds: new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT * 0.25)
        };

        // this._flockHolder.y = -common.STAGE_HEIGHT * 0.25;
        this._flock = new FlockController(this._flockHolder, settings);
        this._flock.populate(2);
        this._flock.wake();

        this._flockHolder2 = new PIXI.Container();
        this.addChild(this._flockHolder2);

        const settings2 = {
            limits: {velocity: 320, force: 8},
            weights: {s: 1.3, a: 0.9, c: 0.8, t: 1.1},
            separation: 200,
            sense: 400,
            targeting: false,
            wrapAround: false,
            bounds: new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT * 0.25)
        };

        // this._flockHolder.y = -common.STAGE_HEIGHT * 0.25;
        this._flock2 = new FlockController(this._flockHolder2, settings2);
        this._flock2.populate(4);
        this._flock2.wake();

        // this sets paperjs up
        this._drawing = new Drawing();
        this._drawing.init();

        this._alphaFilter = new PIXI.filters.AlphaFilter(0.6);
        this._glowFilter = new GlowFilter({
            distance: 30,
            outerStrength: 1,
            innerStrength: 1,
            color: 0x7efd8f,
        });

        const spineKey = "ghost_" + P3.utils.padNum(common.ghostId, 2);

        this._ghost = new DrawingSpine(P3.assets.spineData(spineKey));
        this._ghost.scale.set(0.5);
        this._ghost.autoUpdate = false;
        this._ghost.stateData.defaultMix = 0.2;
        this._ghost.update(0);

        this._ghost.state.setAnimation(0, "chase", true);
        this._ghost.visible = false;
        // this._ghost.filters = [this._bloomFilter, this._glowFilter, this._alphaFilter];
        //this._ghost.filters = [this._advancedBloomFilter, this._glowFilter, this._alphaFilter];
        this._ghost.filters = [this._glowFilter, this._alphaFilter];
        this.addChild(this._ghost);

        const hacks = common.saveData.getSpineHacks("ghost");
        for (let key in hacks) {
            if (hacks.hasOwnProperty(key)) {
                const t = hacks[key];
                const path = new paper.CompoundPath();
                path.importJSON(t.path);

                const slot = this._ghost.skeleton.findSlot(key);
                const sprite = slot.currentSprite ? slot.currentSprite : slot.currentMesh;// first try sprite, fallback to mesh
                const center = this.toLocal(sprite.position, sprite.parent);
                path.position.set(center.x + t.offset.x, center.y + t.offset.y);
                this._ghost.addTextureHack(DrawingTextureHack.create(path, slot, center));
            }
        }

        // we only needed the drawing for the paperjs canvas, so we can destroy after creating
        this._drawing.destroy();

        this._fred = new PIXI.AnimatedSprite([P3.assets.texture("fred_1"), P3.assets.texture("fred_2")]);
        //  this._daphne.scale.set(1.5);
        this._fred.autoUpdate = false;
        this._fred.loop = false;
        this._fred.animationSpeed = 30;
        this._fred.gotoAndStop(0);
        this._fred.anchor.set(0.5, 1);
        this._fred.position.set(common.STAGE_WIDTH * 0.5 - 100, common.STAGE_HEIGHT * 0.5 + 200);
        this.addChild(this._fred);

        this._player = new PlayerCharacter();
        this._player.position.set(100, 300);
        //this._player.scale.set(0.5);
        this.addChild(this._player);

        let skins = common.shaggySkins;
        for (let i = 0; i < skins.length; i++) {
            this._player.hit(skins[i]);
        }
        skins = common.scoobySkins;
        for (let i = 0; i < skins.length; i++) {
            this._player.hit(skins[i]);
        }

        this._ghost.position.set(this._player.x - 400, this._player.y - 60);

        this._leftWall = new PIXI.Sprite(P3.assets.texture("castle_wall"));
        this.addChild(this._leftWall);

        this._gateLeft = new PIXI.Sprite(P3.assets.texture("gates_l"));
        this._gateLeft.visible = false;
        this.addChild(this._gateLeft);

        this._net = new PIXI.spine.Spine(P3.assets.spineData("net"));
        this._net.position.set(common.STAGE_WIDTH * 0.5 + 260, common.STAGE_HEIGHT - 40);
        this._net.state.setAnimation(0, "idle", true);
        this._net.skeleton.setSkinByName("regular");
        this._net.update(0);
        this.addChild(this._net);

        this._van = new PIXI.Sprite(P3.assets.texture("van"));
        this._van.anchor.set(1, 1);
        this._van.position.set(common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this.addChild(this._van);

        this._leftTree = new PIXI.Sprite(P3.assets.texture("trees_l"));
        this.addChild(this._leftTree);

        this._rightTree = new PIXI.Sprite(P3.assets.texture("trees_r"));
        this.addChild(this._rightTree);

        this.createPhoto();

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');
        states.icon = P3.assets.texture('icon_download');

        this._saveButton = new Button(states);
        this._saveButton.clickSoundName = "sfx_click";
        this._saveButton.overSoundName = "sfx_rollover";
        this._saveButton.signals.click.once(this._onSave, this);
        this._saveButton.visible = false;
        this.addChild(this._saveButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');
        states.icon = P3.assets.texture('icon_continue');

        this._continueButton = new Button(states);
        this._continueButton.clickSoundName = "sfx_click";
        this._continueButton.overSoundName = "sfx_rollover";
        this._continueButton.signals.click.once(this._onContinue, this);
        this._continueButton.visible = false;
        this.addChild(this._continueButton);

        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');
        states.icon = P3.assets.texture('icon_restart');

        this._replayButton = new Button(states);
        this._replayButton.clickSoundName = "sfx_click";
        this._replayButton.overSoundName = "sfx_rollover";
        this._replayButton.signals.click.once(this._onReplay, this);
        this._replayButton.visible = false;
        this.addChild(this._replayButton);

        this._ambientSFX = P3.audio.playSound("sfx_castle_exterior_loop", {loop: true});
    }

    createNetSkins(skins) {
        // create new empty skin
        const newSkin = new PIXI.spine.core.Skin("combined-skin");
        // add base skin
        newSkin.addSkin(this._net.spineData.findSkin("regular"));

        this.addNetSkins(skins, this._net, newSkin);

        this._net.skeleton.setSkin(newSkin);

        //Reset slots to remove not used attachments
        this._net.skeleton.setSlotsToSetupPose();
    }

    addNetSkins(skins, spine, newSkin) {
        for (let i = 0; i < skins.length; i++) {
            // add extra skins to base skin
            switch (skins[i]) {
                case ObstacleManager.TYPE.PAINT: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_bucket"));
                    break;
                }
                case ObstacleManager.TYPE.SLIME: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_slime"));
                    break;
                }
                case ObstacleManager.TYPE.SPIDER_FLOOR: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_web"));
                    break;
                }
                case ObstacleManager.TYPE.SPIDER_STRING_A: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_spider2"));
                    break;
                }
                case ObstacleManager.TYPE.SPIDER_STRING_B : {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_spider"));
                    break;
                }
                case ObstacleManager.TYPE.BATS : {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_bat"));
                    break;
                }
                case ObstacleManager.TYPE.HAND : {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_hand"));
                    break;
                }
            }
        }
    }

    destroy() {
        this._ambientSFX && this._ambientSFX.stop();
        this._photo.texture.destroy(true);
        this._screenshotTexture.destroy(true);
        super.destroy();
    }

    resize() {
        super.resize();

        this._saveButton.position.set(common.STAGE_WIDTH * 0.5 - 130, common.STAGE_HEIGHT - 110);
        this._continueButton.position.set(common.STAGE_WIDTH * 0.5 + 40, common.STAGE_HEIGHT - 130);
        this._replayButton.position.set(common.STAGE_WIDTH * 0.5 - 300, common.STAGE_HEIGHT - 100);

        /*
        this._saveButton.position.set(common.STAGE_WIDTH * 0.5 - 220, common.STAGE_HEIGHT - 480);
        this._continueButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 140, common.STAGE_HEIGHT - 300);
        this._replayButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 160, common.STAGE_HEIGHT - 120);
         */
    }

    animateIn() {
        P3.utils.delayg(this._tweens, 2, () => {
            P3.audio.stopMusic();
            P3.audio.playSound("music_ghost_b_end_sting_00");
            this.setState(ResultsScene.STATE.EXIT_DOOR);
        });
    }

    end() {
        this.signals.next.dispatch();
    }

    update(dt = window.deltaTime) {
        super.update();

        this._player.update(dt);
        this._flock.update(dt);
        this._flock2.update(dt);
        // this._velma.update(dt);
        // this._daphne.update(dt);
        this._net.update(dt);
        this._ghost.update(dt);

        this._fred.update(dt);
    }

    createPhoto() {

        this._photoHolder = new PIXI.Container();
        this._photoHolder.position.set(common.STAGE_WIDTH * 0.5 - 160, common.STAGE_HEIGHT * 0.5);
        this._photoHolder.scale.set(0.9);
        this.addChild(this._photoHolder);

        this._photo = new PIXI.Sprite(common.photoTexture || PIXI.Texture.WHITE);
        this._photo.anchor.set(0.5);
        this._photo.rotation = -Math.PI * 0.028;
        this._photo.position.set(-3, -46);
        this._photo.width = 520 * 1.005; // texture size of the photo area keeps changing, so magic numbers
        this._photo.height = 480 * 1.005;
        this._photoHolder.addChild(this._photo);

        this._photoFrame = new PIXI.Sprite(P3.assets.texture("polaroid_frame"));
        this._photoFrame.anchor.set(0.5);
        this._photoHolder.addChild(this._photoFrame);

        const logo = new PIXI.Sprite(P3.assets.texture("SDGW_logo"));
        logo.anchor.set(0.5);
        logo.position.set(-200, -240);
        this._photoHolder.addChild(logo);

        const boomerang = new PIXI.Sprite(P3.assets.texture("boomerang_logo"));
        boomerang.anchor.set(0.5);
        boomerang.rotation = -Math.PI * 0.028;
        boomerang.position.set(30, 260);
        boomerang.scale.set(1.2);
        boomerang.alpha = 0.8;
        this._photoHolder.addChild(boomerang);

        // generate texture then hide
        this._screenshotTexture = common.renderer.generateTexture(this._photoHolder);
        this._photoHolder.visible = false;

        // logo only on screenshot
        boomerang.destroy();

    }

    setState(state) {
        this._state = state;
        this._beginState();
    }

    _beginState() {
        switch (this._state) {
            case ResultsScene.STATE.EXIT_DOOR : {
                P3.audio.playSound("sfx_castle_door_burst_open");
                this._gate.open();

                this._gateLeft.visible = true;

                this._player.run();

                new P3.utils.TWEEN.Tween(this._player, this._tweens)
                    //   .delay(190)
                    .to({x: this._net.x, y: common.STAGE_HEIGHT * 0.5 + 300}, 1200)
                    .easing(P3.utils.TWEEN.Easing.Linear.None)
                    .onComplete(() => {
                        this.createNetSkins(common.skins)
                        this._player.stop();
                        this.setState(ResultsScene.STATE.NET);
                        this._fred.gotoAndPlay(0);
                    })
                    .start();

                this._ghost.visible = true;
                new P3.utils.TWEEN.Tween(this._ghost, this._tweens)
                    .delay(190)
                    .to({x: common.STAGE_WIDTH}, 2000)
                    .easing(P3.utils.TWEEN.Easing.Linear.None)
                    .onComplete(() => {
                        this._ghost.visible = false;
                    })
                    .start();
                break;
            }
            case ResultsScene.STATE.NET : {
                //this._player.trapped();
                this._player.visible = false;
                this._net.state.setAnimation(0, "trapped", false);

                P3.utils.delayg(this._tweens, 2, () => {
                    this.setState(ResultsScene.STATE.PHOTO);
                });

                new P3.utils.TWEEN.Tween(this._net.scale, this._tweens)
                    .to({x: 1.01, y: 0.99}, 1400)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .yoyo(true)
                    .repeat(Infinity)
                    .start();

                P3.audio.playSound("sfx_trap_capture");
                break;
            }
            case ResultsScene.STATE.PHOTO : {
                this._photoHolder.alpha = 0;
                this._photoHolder.visible = true;
                this._photoHolder.rotation = Math.PI * 0.24;

                const end = this._photoHolder.position.clone();
                this._photoHolder.position.set(common.STAGE_WIDTH * 0.5 - 220, -120);

                const a = new P3.utils.TWEEN.Tween(this._photoHolder, this._tweens)
                    .to({y: end.y, rotation: 0}, 980)
                    .easing(P3.utils.TWEEN.Easing.Sinusoidal.Out)
                    .onComplete(_ => {
                        new P3.utils.TWEEN.Tween(this._photoHolder, this._tweens)
                            .to({x: this._photoHolder.x - 4, y: this._photoHolder.y + 4}, 1600)
                            .repeat(Infinity)
                            .yoyo(true)
                            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                            .start();

                        const rotTime = 2100;

                        const rotLeft = new P3.utils.TWEEN.Tween(this._photoHolder, this._tweens)
                            .to({rotation: -Math.PI * 0.005}, rotTime)
                            .yoyo(true)
                            .repeat(1)
                            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

                        const rotRight = new P3.utils.TWEEN.Tween(this._photoHolder, this._tweens)
                            .to({rotation: Math.PI * 0.005}, rotTime)
                            .yoyo(true)
                            .repeat(1)
                            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

                        // chain infinetly
                        rotLeft.chain(rotRight);
                        rotRight.chain(rotLeft);
                        rotLeft.start();
                    });

                new P3.utils.TWEEN.Tween(this._photoHolder, this._tweens)
                    .to({alpha: 1}, 320)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
                    .start();

                new P3.utils.TWEEN.Tween(this._photoHolder, this._tweens)
                    .to({x: end.x}, 900)
                    .easing(P3.utils.TWEEN.Easing.Back.Out)
                    .start();

                this._saveButton.scale.set(0);
                const b = new P3.utils.TWEEN.Tween(this._saveButton.scale, this._tweens)
                    .to({x: 0.9, y: 0.9}, 280)
                    .onStart(() => this._saveButton.visible = true)
                    .easing(P3.utils.TWEEN.Easing.Back.Out);

                this._replayButton.scale.set(0);
                const c = new P3.utils.TWEEN.Tween(this._replayButton.scale, this._tweens)
                    .to({x: 0.9, y: 0.9}, 280)
                    .onStart(() => this._replayButton.visible = true)
                    .easing(P3.utils.TWEEN.Easing.Back.Out);

                this._continueButton.scale.set(0);
                const d = new P3.utils.TWEEN.Tween(this._continueButton.scale, this._tweens)
                    .to({x: 0.9, y: 0.9}, 280)
                    .onStart(() => this._continueButton.visible = true)
                    .easing(P3.utils.TWEEN.Easing.Back.Out);

                a.chain(b);
                b.chain(c);
                c.chain(d);

                a.start();
                /*
           const a = new P3.utils.TWEEN.Tween(this._photoHolder, this._tweens)
               .to({alpha: 1, rotation: 0}, 400)
               .easing(P3.utils.TWEEN.Easing.Quadratic.Out);


           this._saveButton.scale.set(0);
           const b = new P3.utils.TWEEN.Tween(this._saveButton.scale, this._tweens)
               .to({x: 0.9, y: 0.9}, 280)
               .onStart(() => this._saveButton.visible = true)
               .easing(P3.utils.TWEEN.Easing.Back.Out);

           this._replayButton.scale.set(0);
           const c = new P3.utils.TWEEN.Tween(this._replayButton.scale, this._tweens)
               .to({x: 0.9, y: 0.9}, 280)
               .onStart(() => this._replayButton.visible = true)
               .easing(P3.utils.TWEEN.Easing.Back.Out);

           this._continueButton.scale.set(0);
           const d = new P3.utils.TWEEN.Tween(this._continueButton.scale, this._tweens)
               .to({x: 0.9, y: 0.9}, 280)
               .onStart(() => this._continueButton.visible = true)
               .easing(P3.utils.TWEEN.Easing.Back.Out);

           a.chain(b);
           b.chain(c);
           c.chain(d);

           a.start();

            */

                break;
            }
        }
    }

    _onContinue() {
        this.signals.next.dispatch();
    }

    _onReplay() {
        this.signals.previous.dispatch();
    }

    _onSave() {
        saveImage(this._screenshotTexture, () => {
            // display success msg
            // this._successDialog.visible = true;
            // P3.utils.delayg(this._tweens, 2, () => this._successDialog.visible = false);
        });
    }

}

ResultsScene.STATE = {};
ResultsScene.STATE.EXIT_DOOR = "exit";
ResultsScene.STATE.NET = "net";
ResultsScene.STATE.PHOTO = "photo";


